import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { trackBookingCtaClick } from '../../utils/metaPixel';
export function StickyMobileCta() {
  const {
    t
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const contact = document.getElementById('contacto');
      const scrollY = window.scrollY;
      const showAfter = 600;
      const hideBefore = contact ? contact.offsetTop - 600 : Infinity;
      setIsVisible(scrollY > showAfter && scrollY < hideBefore);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    trackBookingCtaClick('sticky_mobile');
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-373" data-mp="18tge1wu6kpr0">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: [0.33, 1, 0.68, 1]
    }} className="lg:hidden fixed bottom-6 left-6 right-6 z-40" data-id="element-374" data-mp="1bfv4udgzb21z">
          <button onClick={scrollToContact} className="w-full bg-brand-dark/95 backdrop-blur-md text-brand-cream rounded-full shadow-2xl px-6 py-4 flex items-center justify-between active:scale-[0.98] transition-transform border border-brand-gold/30" data-id="element-375" data-mp="sp3mimf0k1bg">
            <span className="text-xs font-semibold tracking-[0.15em] uppercase text-brand-cream" data-id="element-376" data-mp="nrty9a3d1vp7">
              {t('stickyCta.text')}
            </span>
            <span className="flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-brand-gold" data-id="element-377" data-mp="9tdkx0azt6y3">
              {t('stickyCta.button')}
              <span data-id="element-378" data-mp="2gg1nvdvpai4r">→</span>
            </span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}